import * as React from 'react'

import { PrivatePage, PrivatePageProps } from 'app2/views/shared';

export function UserPage(props:PrivatePageProps) {
  return <PrivatePage  {...props} />
}
